export default __webpack_public_path__ + "static/media/addGroupRed.2293291a.svg";